let wasm;

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();

let numBytesDecoded = 0;
function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    numBytesDecoded += len;
    if (numBytesDecoded >= 0x7ff00000) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

let WASM_VECTOR_LEN = 0;
const cachedTextEncoder = new TextEncoder();

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
        return cachedTextEncoder.encodeInto(arg, view);
    }
    : function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    });

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = wasm.__externref_table_alloc();
        wasm.__wbindgen_externrefs.set(idx, e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function takeObject(idx) {
    const ret = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return ret;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

export function scramtag() {
    return (""+1e10).replace(/[018]/g,
      c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

const RewriterFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_rewriter_free(ptr >>> 0, 1));

export class Rewriter {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RewriterFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_rewriter_free(ptr, 0);
    }

    rewrite_js(jsconfig, jsflags, encode_url, js, base, url, module) {
        const ptr0 = passStringToWasm0(js, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(base, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.rewriter_rewrite_js(this.__wbg_ptr, jsconfig, jsflags, encode_url, ptr0, len0, ptr1, len1, ptr2, len2, module);
        if (ret[2]) throw takeObject(ret[1]);
        return takeObject(ret[0]);
    }

    rewrite_js_bytes(jsconfig, jsflags, encode_url, js, base, url, module) {
        const ptr0 = passArray8ToWasm0(js, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(base, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.rewriter_rewrite_js_bytes(this.__wbg_ptr, jsconfig, jsflags, encode_url, ptr0, len0, ptr1, len1, ptr2, len2, module);
        if (ret[2]) throw takeObject(ret[1]);
        return takeObject(ret[0]);
    }

    constructor() {
        const ret = wasm.rewriter_new();
        if (ret[2]) throw takeObject(ret[1]);
        this.__wbg_ptr = ret[0] >>> 0;
        RewriterFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
}

if (Symbol.dispose) {
    Rewriter.prototype[Symbol.dispose] = Rewriter.prototype.free;
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_Error_e83987f665cf5504 = function(arg0, arg1) {
        return Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg___wbindgen_boolean_get_6d5a1ee65bab5f68 = function(arg0) {
        const v = typeof(arg0) === 'boolean' ? arg0 : undefined;
        return v === null ? 0xFFFFFF : +!!v;
    };
    imports.wbg.__wbg___wbindgen_is_function_ee8a6c5833c90377 = function(arg0) {
        return typeof(arg0) === 'function';
    };
    imports.wbg.__wbg___wbindgen_string_get_e4f06c90489ad01b = function(arg0, arg1) {
        const obj = typeof(arg1) === 'string' ? arg1 : undefined;
        var ptr1 = obj === null ? 0 : passStringToWasm0(obj, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg___wbindgen_throw_b855445ff6a94295 = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_call_525440f72fbfc0ea = function() { return handleError(function(arg0, arg1, arg2) {
        return arg0.call(arg1, arg2);
    }, arguments); };
    imports.wbg.__wbg_encodeURIComponent_eb634fe3333c48d2 = function(arg0, arg1) {
        return encodeURIComponent(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_get_efcb449f58ec27c2 = function() { return handleError(function(arg0, arg1) {
        return Reflect.get(arg0, arg1);
    }, arguments); };
    imports.wbg.__wbg_new_1acc0b6eea89d040 = function() {
        return {};
    };
    imports.wbg.__wbg_new_81afc06ccd3bd6a5 = function() { return handleError(function(arg0, arg1) {
        return new URL(getStringFromWasm0(arg0, arg1));
    }, arguments); };
    imports.wbg.__wbg_new_e17d9f43105b08be = function() {
        return [];
    };
    imports.wbg.__wbg_new_from_slice_92f4d78ca282a2d2 = function(arg0, arg1) {
        return new Uint8Array(getUint8ArrayMemory0().subarray(arg0 >>> 0, (arg0 >>> 0) + arg1));
    };
    imports.wbg.__wbg_new_with_base_058e1f248f19b984 = function() { return handleError(function(arg0, arg1, arg2, arg3) {
        return new URL(getStringFromWasm0(arg0, arg1), getStringFromWasm0(arg2, arg3));
    }, arguments); };
    imports.wbg.__wbg_origin_af09d36f59ea0c32 = function(arg0, arg1) {
        const ret = passStringToWasm0(arg1.origin, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ret, true);
    };
    imports.wbg.__wbg_scramtag_3a255d78b157986d = function(arg0) {
        const ret = passStringToWasm0(scramtag(), wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ret, true);
    };
    imports.wbg.__wbg_set_c2abbebe8b9ebee1 = function() { return handleError(function(arg0, arg1, arg2) {
        return Reflect.set(arg0, arg1, arg2);
    }, arguments); };
    imports.wbg.__wbg_toString_7da7c8dbec78fcb8 = function(arg0) {
        return arg0.toString();
    };
    imports.wbg.__wbg_toString_8eec07f6f4c057e4 = function(arg0) {
        return arg0.toString();
    };
    imports.wbg.__wbindgen_cast_2241b6af4c4b2941 = function(arg0, arg1) {
        return getStringFromWasm0(arg0, arg1);
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = wasm.__wbindgen_externrefs;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
    };

    return imports;
}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedDataViewMemory0 = null;
    cachedUint8ArrayMemory0 = null;

    wasm.__wbindgen_start();
    return wasm;
}

export function initSync(module) {
    if (wasm !== undefined) return wasm;

    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return __wbg_finalize_init(instance, module);
}

export default function __wbg_init() {
    return initSync(...arguments);
}
